import Representation2d from "../representation2d/Representation2d";
import Representation3d from "../representation3d/Representation3d";
import { createProductRepresentation2d } from "./ProductRepresentation2dFactory";
import { createProductRepresentation3d } from "./ProductRepresentation3dFactory";
import Representation3dTypeEnum from "../representation3d/Representation3dTypeEnum";
import ShapeTypeEnum from "../representation2d/ShapeTypeEnum";
import MaterialPair from "../material/MaterialPair";
import { IMaterialSet } from "../../services/MaterialManager";
import { ElementTypeEnum } from "../../elementTypeMappings";
import { defaultMaterial } from "../../utils/defaultMaterial";
import ProductRepresentation from "./ProductRepresentation";
import { VisualizerUserDataTypeEnum } from "../../interfaces/ProductMeshUserData";
import IProduct from "../../interfaces/IProduct";
import SetMaterial from "../material/SetMaterial";
import CoveringData from "../productData/CoveringData";
import IfcCoveringTypeEnum from "../../enums/IfcCoveringTypeEnum";
import LayerMappingsEnum from "../../enums/LayerMappingsEnum";

const getThreeJsMaterialForRepresentation = (   productType: ElementTypeEnum,
                                                representationType: Representation3dTypeEnum | ShapeTypeEnum,
                                                materialId: number | null,  
                                                materialPairs?: Record<number, MaterialPair>, 
                                                materialSet?: IMaterialSet) : MaterialPair => {

        // Best case scenario, representation has material id and it matches a mapping
        if (    materialId && 
                materialPairs && 
                materialPairs[materialId]   ) {
            return materialPairs[materialId];
        }
        
        // Try to get material from current viewer mode's material set or fall back to default material
        return new MaterialPair(    new SetMaterial(),  
                                    materialSet?.getMaterial(productType, representationType) 
                                                    || defaultMaterial);
    }


const createProductRepresentation = (   representation : Representation2d | Representation3d,
                                        product: IProduct,
                                        materialPairs?: Record<number, MaterialPair>,
                                        materialSet?: IMaterialSet
) : ProductRepresentation | null => {

    const representationType = representation instanceof Representation2d 
                                ? representation.shapeType 
                                : representation.representationType;

    const materialPair = getThreeJsMaterialForRepresentation(   product.productData.productType,
                                                            representationType,
                                                            representation.materialId,
                                                            materialPairs,
                                                            materialSet);
    
    const object3d = representation instanceof Representation2d 
                            ? createProductRepresentation2d(representation, product, materialPair)
                            : createProductRepresentation3d(representation, product, materialPair);

    // Hack to set correct layer for non-textured wall and ceiling coverings
    if (object3d && representation.materialId == null && product.productData.productType == ElementTypeEnum.Covering) {
        const coveringData = product.productData as CoveringData;
        if (coveringData.coveringType == IfcCoveringTypeEnum.CLADDING)
            object3d.layers.set(LayerMappingsEnum.WallCoverings3dNoTexture);
        else if (coveringData.coveringType == IfcCoveringTypeEnum.CEILING)
            object3d.layers.set(LayerMappingsEnum.CeilingCoverings3dNoTexture);
    }

    if (!object3d) {
        return null;
    }

    object3d.name = `${representationType} representation of ${product.productData.productType}`;
    object3d.userData = {
        userDataType: VisualizerUserDataTypeEnum.productMesh,
        product: product // Refactor to product data if possible
    };

    return new ProductRepresentation(object3d);
    
};


export { createProductRepresentation };

